import { useLocation, useNavigate } from 'react-router-dom';

const sectionKicker = 'font-label text-[11px] font-semibold uppercase tracking-[0.12em] text-on-surface-variant';

const destinations = [
  { label: 'Dashboard', icon: 'monitoring', path: '/dashboard' },
  { label: 'All Players', icon: 'groups', path: '/players' },
  { label: 'Leagues', icon: 'trophy', path: '/leagues' },
  { label: 'Blog', icon: 'article', path: '/blog' },
];

export default function NotFound() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <div className="flex flex-col items-center justify-center text-center py-20">
      <span className="material-symbols-outlined text-5xl text-outline-variant mb-4">explore_off</span>
      <p className={`${sectionKicker} mb-1`}>Page Not Found</p>
      <h2 className="font-expanded font-headline text-2xl sm:text-3xl font-bold text-on-surface tracking-tight mb-2">
        Off the radar
      </h2>
      <p className="text-sm text-on-surface-variant mb-6 max-w-md">
        <span className="font-mono text-on-surface">{pathname}</span> doesn't exist. It may have moved, or the link may be wrong.
      </p>
      <div className="flex flex-wrap items-center justify-center gap-2">
        {destinations.map(({ label, icon, path }) => (
          <button
            key={path}
            onClick={() => navigate(path)}
            className="inline-flex items-center gap-2 rounded-lg border border-outline-variant/30 bg-surface-container px-4 py-2.5 text-sm font-bold text-primary hover:border-primary/50 transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/70"
          >
            <span className="material-symbols-outlined text-[18px]">{icon}</span>
            {label}
          </button>
        ))}
      </div>
    </div>
  );
}
